/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JobType = core.serialization.enum_([
    "file",
    "workbook",
    "sheet",
    "space",
    "document",
    "app",
    "agent",
    "autobuild",
    "onboarding",
]);
